module.exports = __webpack_public_path__ + "img/missionEnd-3-w.706abfc4.png";